import BaseReducer from "./BaseReducer";

class ConfirmModalReducer extends BaseReducer {
  domain = "Modals";
  type = "ConfirmModal";

  initialState = {
    open: false,
    title: "Confirmation",
    message: "Are you sure you wish to continue?",
    okLabel: null,
  };
}

const reducer = new ConfirmModalReducer();

export default reducer;
